var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',[_c('div',[_c('span',{staticClass:"ml-1"},[_vm._v(" Brand Partner Center © "+_vm._s(_vm._f("moment")(new Date(),"YYYY")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }